import { render, staticRenderFns } from "./deliveryCharges.vue?vue&type=template&id=2cc4de6f&"
import script from "./deliveryCharges.vue?vue&type=script&lang=js&"
export * from "./deliveryCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports